// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"140":"main_login","496":"main_home"}[chunkId] + "-legacy." + {"140":"7e09088f","496":"dac4829b"}[chunkId] + ".js";
};